// extracted by mini-css-extract-plugin
export default {"main":"RolSelector_main__zZd3Y"};